import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'modules/tooltip/tooltip.component';
import CoinStat from 'modules/stats/coinStat.component';
import { Image, View, SmallText } from 'modules/styled';
import { Platform } from 'react-native';

PostRank.propTypes = {
  horizontal: PropTypes.bool,
  color: PropTypes.string,
  post: PropTypes.object,
};

export default memo(PostRank);

function PostRank({ horizontal, color, post }) {
  const tipText = `Ranking: ${
    Math.round(post?.data?.pagerank) || 0
  } (out of 100)\nVotes: ${post?.data?.upVotes - post?.data?.downVotes || 0}`;
  const tooltipData = { text: tipText, position: horizontal ? 'top' : 'right' };
  // const postRank = post.data
  //   ? Math.round(post?.data?.pagerank) + post?.data?.upVotes - post?.data?.downVotes
  //   : 0;
  // const votes = post.data ? post?.data?.upVotes - post?.data?.downVotes : 0;
  const postRank = Math.round(post?.data?.pagerank);

  return (
    <View
      sx={{
        mx: horizontal ? 1 : 0,
        height: horizontal ? 2 : 5,
        minWidth: horizontal ? 9 : null,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Tooltip name="vote" data={tooltipData} />
      <SmallText sx={{ color: color || 'grey' }}>
        <Image
          resizeMode={'contain'}
          style={{
            width: 10.01,
            height: 10.01,
            opacity: 0.5,
            tintColor: Platform.OS === 'android' ? 'hsla(0,0%,0%,.5)' : null, // for some reason opacity doesn't work on android
            transform: [{ translateY: 0.5 }],
          }}
          source={require('public/img/r.png')}
        />
        <View sx={{ width: 1.0001, height: 0 }} />
        {postRank || 0}

        {post?.data?.balance ? (
          <SmallText>
            {'  '}
            <CoinStat
              noSpace
              spaceBetween={2}
              secondary
              inline
              size={1}
              fs={1.5}
              amount={post?.data?.balance}
            />
          </SmallText>
        ) : null}
      </SmallText>
    </View>
  );
}
